import axios, { AxiosResponse } from "axios";
import { ArrayFromEnvelope, configService, ObjectFromEnvelope } from "./config.service";
import { NormPeriodType } from "../models/normPeriodTypes";
import { NormPeriod } from "../models/normPeriods";
import { convertDateOnlyToUtc } from "../utils/dateUtils";

class NormPeriodTypeService {
  async fetchNormPeriodTypes(): Promise<NormPeriodType[]> {
    return new Promise((resolve, reject) => {
      axios
        .get<NormPeriodType[]>(
          configService.APIInstitutionUrl(
            "norm_period_types.json?institution_id=" + configService.institutionId()
          )
        )
        .then((response: AxiosResponse) => {
          resolve(NormPeriodType.fromJSONArray(ArrayFromEnvelope<NormPeriodType>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async fetchNormPeriods(positonId: number, startDate: Date, endDate: Date): Promise<NormPeriod[]> {
    const utcFra: string = convertDateOnlyToUtc(startDate);
    const utcTilOgMed: string = convertDateOnlyToUtc(endDate);
    return new Promise((resolve, reject) => {
      axios
        .get<NormPeriod[]>(
          configService.APIInstitutionUrl(
            "norm_periods.json?position_id=" +
              positonId +
              "&start_date=" +
              utcFra +
              "&end_date=" +
              utcTilOgMed
          )
        )
        .then((response: AxiosResponse) => {
          resolve(NormPeriod.fromJSONArray(ArrayFromEnvelope<NormPeriod>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async fetchNormPeriodByPositionAndIndex(positonId: number, index: number): Promise<NormPeriod[]> {
    return new Promise((resolve, reject) => {
      axios
        .get<NormPeriod[]>(
          configService.APIInstitutionUrl(
            "norm_periods.json?position_id=" + positonId + "&index=" + index
          )
        )
        .then((response: AxiosResponse) => {
          resolve(NormPeriod.fromJSONArray(ArrayFromEnvelope<NormPeriod>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async createNormPeriodType(normPeriodType: NormPeriodType): Promise<NormPeriodType> {
    return new Promise((resolve, reject) => {
      axios
        .post<NormPeriodType>(
          configService.APIInstitutionUrl("norm_period_types.json"),
          normPeriodType.convertToPostObject()
        )
        .then((response: AxiosResponse) => {
          resolve(NormPeriodType.fromJSON(ObjectFromEnvelope<NormPeriodType>(response.data)));
        })
        .catch((error) => reject(error));
    });
  }
  async updateNormPeriodType(normPeriodType: NormPeriodType): Promise<NormPeriodType> {
    return new Promise((resolve, reject) => {
      axios
        .put<NormPeriodType>(
          configService.APIInstitutionUrl("norm_period_types/" + normPeriodType.id + ".json"),
          normPeriodType.convertToPutObject()
        )
        .then((response: AxiosResponse) => {
          resolve(NormPeriodType.fromJSON(ObjectFromEnvelope<NormPeriodType>(response.data)));
        })
        .catch((error) => reject(error));
    });
  }
  async deleteNormPeriodType(normPeriodId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .delete<NormPeriodType>(
          configService.APIInstitutionUrl("norm_period_types/" + normPeriodId + ".json")
        )
        .then((response: AxiosResponse) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  }
}

export const normPeriodService: NormPeriodTypeService = new NormPeriodTypeService();
